import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectController = createSelector(
  (state: RootState) => state.layout.controller,
  (controller: string) => controller
)

export default selectController
